import { ToastContainer, toast, ToastOptions } from 'react-toastify'
import { CSSProperties } from 'react'
import Icon, { IconTypes } from '~ui/Icon'

import styles from './notification.module.scss'

const Notification: React.FC = () => (
  <ToastContainer
    position="bottom-center"
    autoClose={4000}
    hideProgressBar
    pauseOnFocusLoss={false}
    pauseOnHover={false}
    closeOnClick={false}
    closeButton={false}
    draggable={false}
    className={styles.Notification}
    theme="colored"
  />
)

const toastMessage =
  (messageToShow: string, iconName: IconTypes) =>
    ({ closeToast }: { closeToast?: () => void }) =>
      (
        <div className={styles['toast-message']}>
          <Icon className={styles.icon} name={iconName} />
          <span>{messageToShow}</span>
          <button
            type="button"
            tabIndex={-1}
            onClick={closeToast}
            className={styles['circle-progress-container']}
          >
            <Icon className={styles['circle-progress']} name="circle" />
            <Icon className={styles['circle-child-overlapped']} name="cross" fill="currentColor" />
          </button>
        </div>
      )

export const notify = (message: string, icon?: IconTypes) =>
  toast(toastMessage(message, icon || 'check-filled'))

export const notifySuccess = (messageToShow: string, options?: ToastOptions) =>
  toast(toastMessage(messageToShow, 'check-filled'), {
    className: styles['green-background'],
    style: {
      '--progress-color': 'black',
    } as CSSProperties,
    ...options,
  })

export const notifyError = (messageToShow: string, options?: ToastOptions) =>
  toast(toastMessage(messageToShow, 'exclamation-mark'), {
    className: styles['red-background'],
    style: {
      '--progress-color': 'white',
    } as CSSProperties,
    ...options,
  })

export default Notification
